<template>
  <div class="input-group">
      <div class="input-group__controls">
          <button class="input-group__control input-group__control--up" @click="changeValue(1)"></button>
          <div class="number-input">{{ internalValue }}</div>
          <button class="input-group__control input-group__control--down" @click="changeValue(-1)"></button>
      </div>
  </div>
</template>

<script>
export default {
  name: 'NumberInput',
  props: {
    tag: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      internalValue: this.value || 1,
      min: 1,
    };
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal || 1;
    },
    tag() {
      this.internalValue = this.value || 1;
    }
  },
  methods: {
    changeValue(delta) {
      let newValue = this.internalValue + delta;
      if (newValue >= this.min && newValue <= this.max) {
        this.internalValue = newValue;
        this.$emit('update', this.tag, this.internalValue);
      }
    },
  },
}
</script>